/**
 * Nederlandstalige labels voor de deterministische rapportviewer (M19 / US07A).
 * Classificatie en beschikbaarheid moeten in de UI altijd expliciet zichtbaar
 * zijn: feiten en schattingen worden nooit zonder label naast elkaar gezet en
 * ontbrekende data is "Niet beschikbaar", nooit 0.
 */
export const CLASSIFICATION_LABELS = {
    FACT: 'Feit',
    ESTIMATE: 'Schatting',
    INFERENCE: 'Afleiding',
};
export const AVAILABILITY_LABELS = {
    AVAILABLE: 'Beschikbaar',
    NOT_AVAILABLE: 'Niet beschikbaar',
    NOT_APPLICABLE: 'Niet van toepassing',
    NOT_QUERIED: 'Niet opgevraagd',
    ERROR: 'Fout bij ophalen',
};
/**
 * Herkomstniveau in de weergave. `AI_GENERATED` draagt zijn label bewust in de
 * *tekst*, niet alleen in de opmaak — zie `PROVENANCE_TIERS` in metrics.ts.
 */
export const PROVENANCE_TIER_LABELS = {
    SOURCED: 'A · uit bron',
    DERIVED: 'B · berekend',
    AI_GENERATED: 'C · door AI',
};
/** Prefix die vóór een celwaarde komt te staan; leeg voor gewone bronwaarden. */
export const PROVENANCE_TIER_CELL_PREFIX = {
    SOURCED: '',
    DERIVED: '',
    AI_GENERATED: 'AI: ',
};
export const COMPARABILITY_STATUS_LABELS = {
    COMPARABLE: 'Vergelijkbaar',
    COMPARABLE_WITH_WARNINGS: 'Vergelijkbaar met kanttekeningen',
    NOT_COMPARABLE: 'Niet vergelijkbaar',
    INSUFFICIENT_DATA: 'Onvoldoende gegevens',
};
export const METRIC_CATEGORY_LABELS = {
    WEBSITE: 'Website',
    SEO: 'SEO (organische vindbaarheid)',
    SEA: 'SEA (advertentie-indicaties)',
    SEARCH_CONSOLE: 'Eigen zoekprestaties (Search Console)',
    FIRST_PARTY: 'Eigen websitedata',
    SOCIAL: 'Social & marketing',
    POSITIONING: 'Positionering',
    REPUTATION: 'Reputatie (AI-onderzoek)',
};
export const SOURCE_FAMILY_LABELS = {
    WEBSITE: 'Publieke website',
    GOOGLE_SEARCH: 'Google Zoeken',
    SE_RANKING: 'SE Ranking',
    GOOGLE_ADS: 'Google Ads',
    SEARCH_CONSOLE: 'Search Console',
    SALESFEED: 'Salesfeed',
    SOCIAL_PLATFORMS: 'Socialplatforms',
    KVK_HANDELSREGISTER: 'KVK Handelsregister',
    CREDITSAFE: 'Creditsafe',
    COMPANY_INFO: 'Company.info',
    // P8: de LLM als bron. Het label zegt expliciet "AI", want in het rapport is
    // dit de enige plek waar een lezer ziet dat de waarde niet uit een register komt.
    AI_WEB_RESEARCH: 'AI-websearch (met bronvermelding)',
    MANUAL: 'Handmatig',
};
export const CONNECTOR_RUN_STATUS_LABELS = {
    PENDING: 'In wachtrij',
    RUNNING: 'Bezig',
    SUCCESS: 'Gelukt',
    PARTIAL: 'Gedeeltelijk gelukt',
    FAILED: 'Mislukt',
    SKIPPED: 'Overgeslagen',
    CANCELLED: 'Geannuleerd',
};
//# sourceMappingURL=report-labels.js.map